import React from 'react';

export const reapairNoSealCashReturnConfig = [
  {
    path: '/repair-seal-no',
    component: React.lazy(() => import('./listing/listing')),
  },

  {
    path: '/repair-seal-no/add',
    component: React.lazy(() => import('./add')),
  },

  {
    path: '/repair-seal-no/overview',
    component: React.lazy(() => import('./overview')),
  },
];
